import { render } from "./CouponGroup.vue?vue&type=template&id=f33df686&scoped=true"
import script from "./CouponGroup.vue?vue&type=script&lang=js"
export * from "./CouponGroup.vue?vue&type=script&lang=js"

import "./CouponGroup.vue?vue&type=style&index=0&id=f33df686&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zxr_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33df686"]])

export default __exports__